import { Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IBlacklistGet } from "../../../../models/blacklist";
import { Chip } from "@mui/material";
import MainApiService from "../../../../services/mainApi.service";
import { ITicketFinishReason } from "../../../../models/ticket-finish-reason";

const TICKET_FINISH_REASON_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketFinishReason/";
const ticketFinishReasonService = new MainApiService<ITicketFinishReason>(
  TICKET_FINISH_REASON_ROUTE
);

const translationPath = "chatBot.page.service.ticketFinishReason.";

export const TicketFinishReasonPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const columns: GridColDef<ITicketFinishReason>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "code",
      headerName: t(translationPath + "code") || "Code",
      renderCell: (params) => params.value ?? "-",
    },
    {
      field: "enable",
      headerName: t(translationPath + "status") || "Status",
      maxWidth: 150,
      renderCell: (params) => (
        <Chip
          size="small"
          label={
            params.value
              ? t(translationPath + "active")
              : t(translationPath + "inactive")
          }
          color={params.value ? "success" : "error"}
        />
      ),
    },
  ];
  const handleRowClick = (params: GridRowParams<ITicketFinishReason>) => {
    console.log(params);
    navigate(`${params.id}/edit`);
  };

  const handleAdd = () => {
    navigate("new");
  };

  return (
    <Table<ITicketFinishReason>
      showDefaultMacroFilters={false}
      service={ticketFinishReasonService}
      columns={columns}
      title={
        t(translationPath + "ticket_finish_reason") || "Ticket Finish Reason"
      }
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={
        t(translationPath + "search") || "Search for ticket finish reason"
      }
      addButtonLabel={
        t(translationPath + "add_ticket_finish_reason") ||
        "Add ticket finish reason"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};
